export default "__VITE_ASSET__B3Z9hs9A__"